import { feedKey } from '../lib/feedContext';
import type { Fork } from '../lib/protocol';
import { useScreen } from './store';

const SEED_KEY = feedKey('forq.fork.seed.');
/**
 * Сколько живёт закладка. Пятнадцати секунд не хватало: расширение держит
 * раскладку окон до `PANES_HOLD_MS` (12 с), а бандл в новом документе грузится
 * с холодного кэша. Пока закладка не принята, панель вилки пуста — человек
 * видит «этой вилки в ленте нет» сразу после своего же клика.
 */
const SEED_MS = 30_000;

function seedKey(id: string): string {
  return SEED_KEY + id;
}

/** Карточка, которую только что видели: запасной путь `/app?fork=` рисует её без сокета. */
export function leaveSeed(id: string): void {
  const fork = useScreen.getState().forks.get(id) ?? useScreen.getState().ghosts.get(id)?.fork;
  if (fork === undefined) return;
  try {
    localStorage.setItem(seedKey(id), JSON.stringify({ fork, at: Date.now() }));
  } catch {
    // Приватный режим — окно откроется без заготовки и подождёт кадр.
  }
}

/** Заготовка одного захода. Протухшая или чужая — как будто её не было. */
export function takeSeed(id: string): Fork | null {
  try {
    const raw = localStorage.getItem(seedKey(id));
    if (raw === null) return null;
    localStorage.removeItem(seedKey(id));
    const parsed = JSON.parse(raw) as { fork?: Fork; at?: number };
    if (parsed.fork?.id !== id) return null;
    if (typeof parsed.at !== 'number' || Date.now() - parsed.at > SEED_MS) return null;
    return parsed.fork;
  } catch {
    return null;
  }
}
